/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Addresses from './Addresses/index'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import CreateAction from './CreateAction/index'
import Details from './Details/index'
import Email from './Email/index'
import Notes from './Notes/index'
import Phone from './Phone/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content"
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 maxHeight="67%"
 width={720}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 height="auto"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="medium"
 color={dtColorsNeutral900}
 text="Add New Professional"
/>
<CloseAction
{...childProps}
  viewPath={`${viewPath}/CloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingTop={0}
>
{childProps => (
<React.Fragment>
<Details
{...childProps}
  viewPath={`${viewPath}/Details`}
/>
<Addresses
{...childProps}
  viewPath={`${viewPath}/Addresses`}
/>
<Email
{...childProps}
  viewPath={`${viewPath}/Email`}
/>
<Phone
{...childProps}
  viewPath={`${viewPath}/Phone`}
/>
<Notes
{...childProps}
  viewPath={`${viewPath}/Notes`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<CreateAction
{...childProps}
  viewPath={`${viewPath}/CreateAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}